

























































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    props: {
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: true
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        step: {
            type: Number,
            default: 1 as number
        },
        value: {
            type: Number,
            default: 0 as number
        },
        minValue: {
            type: Number,
            default: 0 as number
        },
        maxValue: {
            type: Number,
            default: 99999 as number
        },
        name: {
            type: String,
            required: true
        },
        gridLayout: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        noMargin: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            uniqueId: (this.specificId !== "") ? this.specificId : uuidv4() as string,
            groupFocused: false,
            options: this.getInputMask(),
            internalValue: this.value,
        };
    },
    computed: {
        inputMainId: function(): string {
            return this.name + "-input-" + this.uniqueId;
        },
        decreaseButtonDisable: function(): boolean {
            if(this.options.min !== null) {
                if (this.internalValue !== null) {
                    return this.internalValue <= this.setMinValue;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        increaseButtonDisable: function(): boolean {
            if(this.options.max !== null) {
                return this.internalValue >= this.setMaxValue;
            } else {
                return false;
            }
        },
        setMinValue: function(): number {
            let minValue = this.minValue;
            if(minValue === null) {
                minValue = this.options.min;
            }
            return minValue;
        },
        setMaxValue: function(): number {
            let maxValue = this.maxValue;
            if(maxValue === null) {
                maxValue = this.options.max;
            }
            return maxValue;
        },
        className: function(): string {
            let className = "input-group input-group--stepper";
            if (this.groupFocused) {
                className += " focused";
            }
            if (this.gridLayout !== "") {
                className += " " + this.gridLayout;
            }
            if (this.errorMessage) {
                className += " input--error";
            }

            return className;
        }
    },
    methods: {
        onFocus: function(): void {
            this.groupFocused = true;
        },
        onBlur: function(): void {
            this.groupFocused = false;
            const value = this.internalValue;
            this.internalValue = this.validateValue(value);
            this.$emit("update-value", this.internalValue);
        },
        decreaseValue: function(): void {
            if(!this.decreaseButtonDisable) {
                const value = this.internalValue - this.step;
                this.internalValue = this.validateValue(value);
                this.$emit("update-value", this.internalValue);
            }
        },
        increaseValue: function(): void {
            if(!this.increaseButtonDisable) {
                const value = this.internalValue + this.step;
                this.internalValue = this.validateValue(value);
                this.$emit("update-value", this.internalValue);
            }
        },
        validateValue: function(value: number): number {
            if(this.setMinValue !== null && value < this.setMinValue) {
                return this.setMinValue;
            } else if(this.setMaxValue !== null && value > this.setMaxValue ) {
                return this.setMaxValue;
            } else {
                return value;
            }
        }
    },
});
